import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { EntityService } from 'src/app/_core/entity.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';

import { routerTransition } from 'src/app/_core/static/animations';
import {DialogsService} from "../../_services/dialogs.service";

@Component({
    selector: 'app-shared-order-join',
    templateUrl: './shared-order-join.component.html',
    styleUrls: ['./shared-order-join.component.scss'],
    host: {
        //'class': 'host-default',
        '[@routerTransition]': '',
    },
    animations: [
        routerTransition
    ],
    standalone: false
})
export class SharedOrderJoinComponent {
	$storage: any;
	loading = true;
	data: any = {};
	tpConfig: any = {};
	hideUI: boolean;
	public contactForm;

	constructor(
		public appService: AppService,
		public authService: AuthService,
		public entityService: EntityService,
		public dialogsService: DialogsService,
		public tabitPayService: TabitPayService,
	) {
		this.$storage = this.tabitPayService.$storage;
		this.tpConfig = _.get(this.$storage.site, 'tabitpay', {});



		this.dialogsService.signInPrompt(this.$storage.contact, 'tableOrderJoin').then(() => {
			this.loading = false;
			this.init();
		}).catch(err => {
			this.appService.goBack();
		});

	}

	init() {
		const phone = localStorage.getItem('c_phone') || '';
		const name = localStorage.getItem('c_name') || '';
		this.contactForm = new UntypedFormGroup({
			//phone: new UntypedFormControl(phone, [Validators.required]),
			//name: new UntypedFormControl(name, [Validators.required]),
			orderNumber: new UntypedFormControl('', [Validators.required]),
		});
	}


	joinSharedOrder() {
		if (!this.contactForm.valid) {
			//this.contactForm.get("phone").markAsTouched({ onlySelf: true });
			//this.contactForm.get("name").markAsTouched({ onlySelf: true });
			this.contactForm.get("orderNumber").markAsTouched({ onlySelf: true });
			return;
		}
		let userDetails: any = {}

		const phone = this.contactForm.value.phone;
		userDetails.phone = phone;

		const name = this.contactForm.value.name;
		userDetails.name = name;

		const orderNumber = this.contactForm.value.orderNumber;

		this.entityService.getOrderById(this.$storage.organization, orderNumber).then(response => {
			let resultURL = `${document.location.origin}/?site=${this.$storage.organization}&oid=${response.order?._id || orderNumber}`;
			document.location.replace(resultURL);
		}).catch(e => {
			this.appService.alert({ content: 'SERVER_MESSAGES.INVALID_ORDER_ID' });
		}).then(o => {
			this.appService.stopBlock();
		});

	}

}
